<template>
	<div class="match-data_row">
		<div class="match-data_col-1">
			<div class="match-tennis_time" v-if="isInprogress" v-text="event.status_desc"></div>
			<div class="match-tennis_date" v-else v-text="statusText"></div>
		</div>
		
		<div class="match-data_col-7" v-text="event.event_name"></div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		props: ['event'],
		
		computed: {
			statusText() {
				if (this.event.status === 'finished') {
					return 'Завершен';
				} else if (this.event.status === 'notstarted') {
					return this.getDate(this.event.startdate);
				}
				
				return this.getTime(this.event.startdate);
			},
			isInprogress() {
				return this.event.status === 'inprogress';
			}
		},
		
		methods: {
			getDate(date) {
				if (moment(date).format('DD-MM-YYYY') === moment().startOf('day').format('DD-MM-YYYY')) {
					return moment(date).format('HH:mm');
				}
				return moment(date).format('DD.MM');
			},
		}
	}
</script>

<style scoped>

</style>